module.exports = __webpack_public_path__ + "img/giraffe.c938c0b3.png";